import { INCREMENT_LOADER_COUNT, DECREMENT_LOADER_COUNT, LoaderActions } from '../actions/loader.actions';

export class LoaderState { count: number; }

const intitialState: LoaderState = {
    count: 0
};

export function loaderReducer(state: LoaderState = intitialState, action: LoaderActions) {
    switch (action.type) {
        case INCREMENT_LOADER_COUNT: {
            return {
                ...state,
                count: state.count + 1
            };
        }
        case DECREMENT_LOADER_COUNT: {
            return {
                ...state,
                count: state.count - 1 >= 0 ? state.count - 1 : 0
            };
        }

        default: return state;
    }
}
